import { useEnsAddress } from "wagmi";
import { useParams } from "react-router-dom";
import { isAddress } from "viem";
import { getChains } from "common";
import Footer from "common/src/components/Footer";
import { ContributionHistoryContainer } from "./components/ContributionHistoryContainer";
import Navbar from "../common/Navbar";
import Breadcrumb from "../common/Breadcrumb";

// TODO: what to display if the address is not correct? '/contributors/123'
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ViewContributionHistoryPage() {
  const {
    address: paramsAddress = ""
  } = useParams();
  const chainIds = getChains().map(chain => chain.id);
  const {
    data: ensResolvedAddress
  } = useEnsAddress({
    name: isAddress(paramsAddress) ? undefined : paramsAddress,
    chainId: 1
  });
  const address = ensResolvedAddress !== null && ensResolvedAddress !== void 0 ? ensResolvedAddress : paramsAddress;
  const breadCrumbs = [{
    name: "Explorer Home",
    path: "/"
  }, {
    name: "Donation history",
    path: `/contributors/${address}`
  }];
  if (!paramsAddress) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: "h-screen",
    children: [/*#__PURE__*/_jsx(Navbar, {
      showWalletInteraction: true
    }), /*#__PURE__*/_jsxs("div", {
      className: "relative top-16 lg:mx-20 xl:mx-20 px-4 py-7 h-screen",
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex pb-4",
        "data-testid": "bread-crumbs",
        children: /*#__PURE__*/_jsx(Breadcrumb, {
          items: breadCrumbs
        })
      }), /*#__PURE__*/_jsx(ContributionHistoryContainer, {
        address: address,
        chainIds: chainIds
      }), /*#__PURE__*/_jsx("div", {
        className: "mt-24 mb-11 h-11",
        children: /*#__PURE__*/_jsx(Footer, {})
      })]
    })]
  });
}